import { LegendEntry } from 'components/LegendEntry';
import { Colors } from 'pages/Shipments/HistoricalPerDiem/components/colors';
import * as React from 'react';
import { OutstandingFeesType } from 'services/clients/insights';

const DemurrageLegend: React.FC = () => {
  return (
    <div>
      <LegendEntry fill={Colors.NonDisputable} label="Demurrage" />
    </div>
  );
};

const PerDiemLegend: React.FC = () => {
  // TODO: Update this to reflect both disputable and non disputable per diem
  return (
    <div>
      <LegendEntry fill={Colors.NonDisputable} label="Per diem" />
    </div>
  );
};

export const Legend: React.FC<{ type: OutstandingFeesType }> = (props) => {
  const { type } = props;
  switch (type) {
    case OutstandingFeesType.Demurrage:
      return <DemurrageLegend />;
    case OutstandingFeesType.PerDiem:
      return <PerDiemLegend />;
    default:
      return null;
  }
};
